<template>
    <div class="bg-slate-50 grid my-5 max-md:container md:p-4 shadow md:rounded-lg">
        <div class="flex flex-row justify-between">
            <div class="flex items-center">
                <span class="flex-initial icon icon-folder-marked w-8 h-8 mr-2"></span>
                <h2 class="flex-1 text-xl line-clamp-2 leading-7 md:text-2xl">
                    {{ item.h2 }}
                </h2>
            </div>
        </div>

        <div :class="'flex flex-row flex-wrap mt-4 -mb-2'">
            <BtnCta
                v-for="link in item.data"
                :key="link.button_text"
                variant="secondary"
                :href="link.button_link"
                :label="link.button_text"
                class="mr-4 mb-2"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'WidgetLink',
    props: {
        item: {
            type: Object,
            required: true,
        },
        appearance: {
            type: String,
            required: false,
            default: null,
        },
        appearanceH2: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped></style>
